module.exports = __webpack_public_path__ + "static/media/2.ccf0ec56.jpg";